import {Injectable } from '@angular/core';
import API from '../../../modules/common/services/api.config.json';
import { ApiService } from '../../../modules/common/services/api.service';
import { Observable } from 'rxjs';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { UntypedFormBuilder,FormGroup,Validators,FormControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class LabourService {

  constructor(
    private apiService: ApiService,
    private fb : UntypedFormBuilder
  ) { }
  
  poblacionForm =this.fb.group({
    Poblacion:['',Validators.required],
    Comunidad:[''],
  });
  fechaForm =this.fb.group({
    Fecha:['',Validators.required],
    Poblacion:[''],
    Level:[''],
    Comunidad:['']

  });
  
  getLabourTreeView(): Observable<RestResponse> {
    let url = `${API.Labour.getLabourTreeView}`;
    return this.apiService.get(url);
  }
  addAddPoblacion(formData:any): Observable<RestResponse> {
    let url = `${API.Labour.addAddPoblacion}`;
    return this.apiService.post(url,formData);
  }
  deletePoblacion(formData:any): Observable<RestResponse> {
    let url = `${API.Labour.deletePoblacion}`;
    return this.apiService.post(url,formData);
  }
  getFetchaList(level:string,fetcha:string,comunidad:string,poblacion:string): Observable<RestResponse> {
    let url = `${API.Labour.getFetchaList}`;
    url = url.replace('{level}', level);
    url = url.replace('{fetcha}', fetcha);
    url = url.replace('{comunidad}', comunidad);
    url = url.replace('{poblacion}', poblacion);
    return this.apiService.get(url);
  }
  addFetcha(formData:any): Observable<RestResponse> {
    let url = `${API.Labour.addFetcha}`;
    return this.apiService.post(url,formData);
  }
  deleteFetcha(formData:any): Observable<RestResponse> {
    let url = `${API.Labour.deleteFecha}`;
    return this.apiService.post(url,formData);
  }

}


